import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Address } from "../../../../shared/ui/Address";
import { ICompanyUpdateResource } from "../../shared/types";
import {
	PrimaryLabel,
	ViewPageSection,
	ViewPageSectionBody,
	ViewPageSectionHeader,
	ViewTagsSection,
} from "../../shared/view";
import { CompanyTestDriveLinks } from "./CompanyTestDriveLinks";

const CompanyPageSectionHeader = styled(ViewPageSectionHeader)`
	display: flex;
	justify-content: space-between;
`;

const StyledPrimaryLabel = styled(PrimaryLabel)`
	align-self: center;
`;

const InfoBlock = styled.div`
	display: flex;
	gap: ${({ theme }) => theme.spacing(3)};
	${({ theme }) => theme.breakpoints.tablet} {
		min-width: 200px;
	}
`;

export const ArchivedCompanyOverview: FC<{ company: ICompanyUpdateResource }> = ({ company }) => {
	const { t } = useTranslation();

	return (
		<>
			<ViewPageSection style={{ gridArea: "general" }}>
				<CompanyPageSectionHeader>
					{t("General")}
					<CompanyTestDriveLinks companyId={company.id} />
				</CompanyPageSectionHeader>
				<ViewPageSectionBody>
					<InfoBlock>
						<div>{company.name}</div>
						<div>
							{company.tenants
								.map((tenant) => {
									if (company.archivedByTenants.some((x) => x.id === tenant.id)) {
										return `(${t("Archived")}) ${tenant.name}`;
									}
									return tenant.name;
								})
								.join(", ")}
						</div>
					</InfoBlock>
				</ViewPageSectionBody>
			</ViewPageSection>

			<ViewPageSection style={{ gridArea: "address" }}>
				<ViewPageSectionHeader>{t("Addresses")}</ViewPageSectionHeader>
				<ViewPageSectionBody>
					{company.addresses.map((address) => (
						<InfoBlock key={`address-${address.id}`}>
							<Address address={address} />
							{address.isPrimary && <StyledPrimaryLabel />}
						</InfoBlock>
					))}
				</ViewPageSectionBody>
			</ViewPageSection>

			<ViewTagsSection tags={company.tags} />
		</>
	);
};
